import { GET_CATEGORY_REQUEST, GET_CATEGORY_SUCCESS, GET_CATEGORY_FAIL,
    CREATE_CATEGORY_REQUEST, CREATE_CATEGORY_SUCCESS, CREATE_CATEGORY_FAIL,
    UPDATE_CATEGORY_REQUEST, UPDATE_CATEGORY_SUCCESS, UPDATE_CATEGORY_FAIL,
    DELETE_CATEGORY_REQUEST, DELETE_CATEGORY_SUCCESS, DELETE_CATEGORY_FAIL} from '../types/categoryTypes'
import Axios from 'axios'
import APP_CONSTANT from '../../config/constants'


export const deleteCategory = () => async (dispatch) => {
    dispatch({ type: DELETE_CATEGORY_REQUEST });
    try {
        const headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customerNo": localStorage.getItem('customerNo'),
            "userId": localStorage.getItem('userId'),
        }
        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}public/api/category/delete`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: DELETE_CATEGORY_SUCCESS, payload: data });
        
        console.log("====Data", data)
        alert(data.message, data.data)
        window.location.href = '/category'
    } catch (error) {
        dispatch({ type: DELETE_CATEGORY_FAIL, payload: error.message })
    }
}

export const updateCategory = (uploadData) => async (dispatch) => {
    dispatch({ type: UPDATE_CATEGORY_REQUEST });
    try {
        const headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customerNo": localStorage.getItem('customerNo'),
            "userId": localStorage.getItem('userId'),
            "categoryName": uploadData.categoryName,
            "categoryId": uploadData.categoryId
        }
        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}public/api/category/update`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: UPDATE_CATEGORY_SUCCESS, payload: data });
        
        console.log("====Data", data)
        alert(data.message, data.data)
        window.location.href = '/category'
    } catch (error) {
        dispatch({ type: UPDATE_CATEGORY_FAIL, payload: error.message })
    }
}


export const getCategory = () => async (dispatch) => {
    dispatch({ type: GET_CATEGORY_REQUEST });
    try {
       
        let token = localStorage.getItem('apiToken')
        let customerNo = localStorage.getItem('customerNo')
        let userId = localStorage.getItem('userId')
        
        const { data } = await Axios.get(`${APP_CONSTANT.BASE_URL}masters/psCategory?userId=${userId}&customerNumber=${customerNo}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": token,
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: GET_CATEGORY_SUCCESS, payload: data });
        
        console.log("====Data", data)
    } catch (error) {
        dispatch({ type: GET_CATEGORY_FAIL, payload: error.message })
    }
}

export const createCategory = (values) => async (dispatch) => {
    dispatch({ type: CREATE_CATEGORY_REQUEST });
    try {
        const headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customerNo": localStorage.getItem('customerNo'),
            "userId": localStorage.getItem('userId'),
            "categoryName": values.categoryName
        }
        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}public/api/category/create`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: CREATE_CATEGORY_SUCCESS, payload: data });
        alert(data.message)
        window.location.href = '/category'
    } catch (error) {
        dispatch({ type: CREATE_CATEGORY_FAIL, payload: error.message })
    }
}
